import './Aguarde.css';
import { useNavigate } from 'react-router-dom'


function Aguarde() {

    setTimeout(() => {
        navigate("/informacoes")
    }, 8000);

    const navigate = useNavigate();

    return (
        <div className="home">
            <div className='backgroundLateral'></div>
            <div>
                <div className='aguarde'>
                    Recebemos a sua proposta e estamos verificando algumas informações. Aguarde alguns momentos.
                    <div className='cb'></div>
                </div>
            </div>
            <div className='backgroundLateral'></div>
        </div >
    );
}

export default Aguarde;